






















































import Vue from "vue";
import AgreementService from "@/services/agreementService";
import { File } from "@/models/agreement";

export default Vue.extend({
  data() {
    return {
      files: [] as File[],
      isLoaded: false
    };
  },
  name: "Agreement",

  async created() {
    this.isLoaded = true;
    const jwt = window.localStorage.getItem("jwt");
    if (jwt) {
      const agreementService = new AgreementService(jwt);
      const response = await agreementService.getAgreement();
      if (response !== undefined && response !== null) {
        if (response.data !== undefined && response.data !== null) {
          this.files = response.data.files;
        }
      }
    }
    this.isLoaded = false;
  }
});
